// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { StyledIcon, StyledTypography } from "@insite/mobius/Link";
import getContrastColor from "@insite/mobius/utilities/getContrastColor";
import resolveColor from "@insite/mobius/utilities/resolveColor";
import { xBaseTheme } from "@mcmc/XDL/types";
import { RobotoCondensed } from "@mcmc/XDL/Utilities/sharedStyles";
import { css } from "styled-components";

export default {
    defaultProps: {
        color: "primary",
        typographyProps: {
            weight: 700,
            ...RobotoCondensed,
            size: "inherit",
            lineHeight: "inherit",
            css: css`
                letter-spacing: 0.21px;
            `,
        },
        css: css`
            &:disabled,
            &[disabled] {
                outline: none;
                opacity: 0.5;
                cursor: not-allowed;
            }

            ${({ theme, _color, iconColor, hoverStyle }: any) => {
                let hoverColor;
                let iconHover;
                iconColor = iconColor || _color;

                if (hoverStyle && hoverStyle.color) {
                    hoverColor = resolveColor(hoverStyle.color, theme);
                    iconHover = hoverColor;
                } else {
                    if (_color === "secondary") {
                        hoverColor = resolveColor("primary", theme);
                    } else if (_color === "primary") {
                        hoverColor = resolveColor("secondary", theme);
                    } else {
                        hoverColor = getContrastColor(_color, theme);
                    }

                    if (iconColor === "secondary") {
                        iconHover = resolveColor("primary", theme);
                    } else if (iconColor === "primary") {
                        iconHover = resolveColor("secondary", theme);
                    } else {
                        iconHover = getContrastColor(iconColor, theme);
                    }
                }

                return css`
                    &:hover {
                        ${/* sc-selector */ StyledIcon} {
                            color: ${iconHover};
                        }
                        ${/* sc-selector */ StyledTypography} {
                            color: ${hoverColor};
                        }
                    }
                `;
            }}
        `,
    },
} as xBaseTheme["link"];
